import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  return (
    <nav
      {...props}
      className={classes}
    >
      <ul className="list-reset">
        <li >
          <Link style={{color:'white'}} to="/about-us">About Us</Link>
        </li>
        <li>
          <Link style={{color:'white'}} to="/privacy-policy">Privacy Policy</Link>
        </li>
        <li>
          <Link style={{color:'white'}} to="/contact-us">Contact Us</Link>
        </li>
       
      </ul>
    </nav>
  );
}

export default FooterNav;